import Relay from 'react-relay';
import MyCollection from './MyCollection';
import PageHeader from '../shared/PageHeader';
import ObjectEntry from '../Object/Entry';
import PersonEntry from '../Person/Entry';
import settings from '../../../config/settings';

const MyCollectionContainer = Relay.createContainer(MyCollection, {
    initialVariables: {
        limit: settings.defaultLimitNumberOfRecords,
        isEditMode: false,
        objectsIds: [],
        designersIds: [],
        producersIds: [],
        lastUpdate: null,
    },
    fragments: {
        store: () => Relay.QL`
            fragment on Store {
                lang,
                ${PageHeader.getFragment('store')},
                myCollectionObjects(first: $limit, objectsIds: $objectsIds) {
                    edges {
                        node {
                            id,
                            ${ObjectEntry.getFragment('object')},
                        }
                    }
                },
                myCollectionDesigners(first: $limit, designersIds: $designersIds) {
                    edges {
                        node {
                            id,
                            ${PersonEntry.getFragment('person')},
                        }
                    }
                },
                myCollectionProducers(first: $limit, producersIds: $producersIds) {
                    edges {
                        node {
                            id,
                            ${PersonEntry.getFragment('person')},
                        }
                    }
                },
            }
        `
    }
});

export default MyCollectionContainer;


// WEBPACK FOOTER //
// ./app/components/MyCollection/index.js